// extracted by mini-css-extract-plugin
export default {"formHeading":"lJ-z","form":"mJ-z","submitBtn":"nJ-z","disabled":"oJ-z","input":"pJ-z","error":"qJ-z","submitMsg":"rJ-z","signIn":"sJ-z"};